import { useState } from 'react';
import { Plus, FileCode } from 'lucide-react';

interface ConfigItem {
  path: string;
  name: string;
}

interface ConfigItemListProps {
  items: ConfigItem[];
  selectedPath: string | null;
  onSelect: (path: string) => void;
  onCreate: (name: string) => void;
  placeholder: string;
  newLabel: string;
}

export function ConfigItemList({ items, selectedPath, onSelect, onCreate, placeholder, newLabel }: ConfigItemListProps) {
  const [creating, setCreating] = useState(false);
  const [newName, setNewName] = useState('');

  function handleCreate() {
    if (!newName.trim()) return;
    onCreate(newName.trim());
    setCreating(false);
    setNewName('');
  }

  return (
    <div className="w-48 shrink-0 space-y-1">
      {items.map((item) => (
        <button
          key={item.path}
          onClick={() => onSelect(item.path)}
          className={`w-full text-left px-3 py-1.5 rounded text-sm flex items-center gap-2 ${
            selectedPath === item.path
              ? 'bg-purple-50 dark:bg-purple-900/20 text-purple-700 dark:text-purple-300'
              : 'text-slate-600 dark:text-slate-400 hover:bg-slate-50 dark:hover:bg-slate-800'
          }`}
        >
          <FileCode className="w-3.5 h-3.5 shrink-0" />
          <span className="truncate">{item.name}</span>
        </button>
      ))}

      {creating ? (
        <div className="flex gap-1 mt-2">
          <input
            type="text"
            value={newName}
            onChange={(e) => setNewName(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && handleCreate()}
            placeholder={placeholder}
            autoFocus
            className="flex-1 px-2 py-1 rounded border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 text-xs font-mono text-slate-900 dark:text-slate-100"
          />
          <button onClick={handleCreate} className="px-2 py-1 rounded bg-purple-600 text-white text-xs">
            OK
          </button>
        </div>
      ) : (
        <button
          onClick={() => setCreating(true)}
          className="w-full flex items-center gap-1 px-3 py-1.5 rounded text-xs text-slate-500 hover:text-slate-700 dark:hover:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-800"
        >
          <Plus className="w-3.5 h-3.5" /> {newLabel}
        </button>
      )}
    </div>
  );
}
